<template>
  <div class="inspectTimeoutDetailData">
    <div
      class="col-12 row text-center mx-0 table-responsive px-0"
      style="max-height: 610px;"
    >
      <table class="inspectTimeoutDetailData-table-detail sticky w-100">
        <thead>
          <tr>
            <th
              colspan="8"
              style="
                background-color: #4b8c80!important;
                color: #ffffff!important;
                border-color: #4b8c80;
                font-family: 'dfyuanstd-w7';
                font-size: 1.125rem;
              "
            >
              超時分析
            </th>
          </tr>
          <tr>
            <th
              v-for="(data, index) in inspectTimeoutDetailDataFields"
              :key="index"
            >
              {{ data.label }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, itemIndex) in inspectTimeoutDetailDataItem"
            :key="itemIndex"
          >
            <td
              v-for="(data, fieldsIndex) in inspectTimeoutDetailDataFields"
              :key="fieldsIndex"
              v-if="item[data.key] != undefined"
              :rowspan="data.rowspan == true ? item.timeout_qty : false"
              :class="{
                rowspan: fieldsIndex == 0,
                'table-col-click':
                  data.key == 'batch' || data.key == 'last_time'
              }"
              @click="
                data.key == 'batch'
                  ? query_workInspData(data.key, item['main_insp'])
                  : data.key == 'last_time'
                  ? query_deviceOperateData(
                      data.key,
                      item['main_insp'],
                      item[data.key]
                    )
                  : ''
              "
            >
              <template v-if="data.key == 'batch_qty'">
                {{ item[data.key].toLocaleString("en-US") }}
              </template>
              <template v-else-if="data.key == 'inspect_qty'">
                {{ item[data.key].toLocaleString("en-US") }}
              </template>
              <template v-else-if="data.key == 'timeout_qty'">
                {{ item[data.key].toLocaleString("en-US") }}
              </template>
              <template v-else>
                {{ item[data.key] }}
              </template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <modal
      :modalShow="modalShow"
      size="xl"
      headerClass="mes-modal-title"
      footerClass="d-none"
    >
      <template v-slot:modalheader>
        <button type="button" class="close" @click="toggle_modal()">×</button>
      </template>
      <template v-slot:default>
        <b-row>
          <b-col cols="12" class="px-5">
            <template v-if="modalType == 'batch'">
              <b-row class="mx-0" style="">
                批號:{{ modalValue }}
                <b-col
                  cols="12"
                  class=""
                  style="margin-top: 1.5rem; background-color: #f2f2f2"
                >
                  <inspectionUseInformation
                    :headerShow="'false'"
                    class="text-left px-0"
                  />
                </b-col>
              </b-row>
            </template>
            <template v-else-if="modalType == 'last_time'">
              <b-col cols="12" class="text-center" style="margin-top: 2rem">
                <queryResult />
              </b-col>
              <stackBar
                style="margin-top: 2rem; padding: 0px 15px"
                :stacksBarClass="stacksBarClass"
                :stacksBarMaxValue="stacksBarMaxValue"
                :stacksData="
                  stacksBar_data != '' ? stacksBar_data : stacksBarDefault
                "
                :stacksSize="'normal'"
              />
              <b-col
                cols="12"
                class="text-right mx-0 px-0"
                style="margin-top: 0.6rem"
              >
                <operateLogData class="text-left" />
              </b-col>
            </template>
          </b-col>
        </b-row>
      </template>
    </modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import modal from "@/components/modal.vue";
import inspectionUseInformation from "@/components/inspectionUseInformation.vue";
import queryResult from "@/components/queryResult.vue";
import stackBar from "@/components/stackBar.vue";
import operateLogData from "@/components/operateLogData.vue";
export default {
  name: "inspectTimeoutDetailData",
  data() {
    return {
      modalShow: false,
      modalType: null,
      modalValue: "",
      stacksBar_data: "",
      stacksBarDefault: {
        default: [
          {
            status: null,
            endTime: "2021-04-08 08:00:29",
            alarmDetail: "",
            startTime: "2021-04-08 08:00:00",
            duration_number: 0
          }
        ]
      }
    };
  },
  computed: {
    ...mapGetters({
      axiosResult: "commonaxios/get_axiosResult",
      selectPage: "getlogin/get_selectPage",
      inspectTimeoutDetailDataFields:
        "inspectTimeoutDetailData/get_inspectTimeoutDetailDataFields",
      inspectTimeoutDetailDataItem:
        "inspectTimeoutDetailData/get_inspectTimeoutDetailDataItem",
      inspectFactory: "inspectTimeoutDetailData/get_inspectFactory",
      stacksBarClass: "stackBar/get_stacksBarClass",
      stacksBarMaxValue: "stackBar/get_stacksBarMaxValue"
    })
  },
  components: {
    modal,
    inspectionUseInformation,
    queryResult,
    stackBar,
    operateLogData
  },
  methods: {
    ...mapActions({
      axiosAction: "commonaxios/axiosAction",
      set_alertMsg: "alertmodal/set_alertMsg",
      settimeout_alertModal: "alertmodal/settimeout_alertModal",
      trigger_loadScreenModal: "loadscreenmodal/trigger_loadScreenModal",
      set_inspectionUseSingleProcess:
        "inspectionUseInformation/set_inspectionUseSingleProcess",
      set_inspectionUseInformationData:
        "inspectionUseInformation/set_inspectionUseInformationData",
      set_queryResultItem: "queryResult/set_queryResultItem",
      set_operateLogDataItem: "operateLogData/set_operateLogDataItem"
    }),
    toggle_modal() {
      let vm = this;
      vm.modalShow = !vm.modalShow;
    },
    query_workInspData(items, value) {
      let vm = this;
      vm.modalType = items;
      let value_array = value.split("_");
      let device_name = value_array[1];
      let work_code = value_array[2];
      let timestamp = value_array[3];
      vm.trigger_loadScreenModal();
      var params = {};
      params["vuePage"] = vm.selectPage;
      params["methods"] = "POST";
      params["device_name"] = device_name;
      params["work_code"] = work_code;
      params["timestamp"] = timestamp;
      params["site"] = vm.inspectFactory;
      params["whichFunction"] = "getWorkInspData";
      vm.axiosAction(params).then(() => {
        vm.trigger_loadScreenModal();
        var result = vm.axiosResult;
        if (result["Response"] == "ok") {
          vm.modalValue = work_code;
          vm.toggle_modal();
          let inspectionUseInformationData =
            result.QueryTableData.inspectionUseInformationData;
          vm.set_inspectionUseSingleProcess(false);
          vm.set_inspectionUseInformationData(inspectionUseInformationData);
        } else {
          vm.set_inspectionUseInformationData({});
          vm.set_alertMsg(result.Response);
          vm.settimeout_alertModal();
        }
      });
    },
    query_deviceOperateData(items, value, last_time) {
      let vm = this;
      vm.modalType = items;
      let value_array = value.split("_");
      let process = value_array[0];
      let device_name = value_array[1];
      vm.trigger_loadScreenModal();
      var params = {};
      params["vuePage"] = vm.selectPage;
      params["methods"] = "POST";
      params["process"] = process;
      params["device_name"] = device_name;
      params["timestamp"] = last_time;
      params["site"] = vm.inspectFactory;
      params["whichFunction"] = "getDeviceOperateData";
      vm.axiosAction(params).then(() => {
        vm.trigger_loadScreenModal();
        var result = vm.axiosResult;
        if (result["Response"] == "ok") {
          vm.toggle_modal();
          let operateLogData = result.QueryTableData.operateLogData;
          let resultItemData = result.QueryTableData.resultItemData;
          vm.stacksBar_data = "";
          vm.stacksBar_data = result.QueryTableData.stacksBar_data;
          vm.set_operateLogDataItem(operateLogData);
          vm.set_queryResultItem(resultItemData);
        } else {
          vm.stacksBar_data = "";
          vm.set_operateLogDataItem([]);
          vm.set_queryResultItem([]);
          vm.set_alertMsg(result.Response);
          vm.settimeout_alertModal();
        }
      });
    }
  }
};
</script>

<style></style>
<style lang="scss">
.inspectTimeoutDetailData-table-detail {
  border-collapse: separate;
  border-spacing: 0;
}
.inspectTimeoutDetailData-table-detail.sticky {
  margin-bottom: 0;
}
.inspectTimeoutDetailData-table-detail.sticky > thead,
.inspectTimeoutDetailData-table-detail.sticky > thead > tr > th {
  position: sticky;
  top: 0;
}
.inspectTimeoutDetailData-table-detail > table > thead > tr > th {
  z-index: 1 !important;
}
.inspectTimeoutDetailData-table-detail th,
.inspectTimeoutDetailData-table-detail td {
  height: 2.5rem;
  min-width: 115px;
  padding: 0.45rem;
  border-color: #999999 !important;
  border-bottom: 1px solid #999999 !important;
  border-right: 1px solid;
  font-weight: normal;
  font-size: 1rem;
  font-family: "dfyuanstd-w5";
  vertical-align: middle !important;
}
.inspectTimeoutDetailData-table-detail td {
  font-size: 1rem;
}
.inspectTimeoutDetailData-table-detail td.table-col-click {
  cursor: pointer;
}
.inspectTimeoutDetailData-table-detail th:first-child,
.inspectTimeoutDetailData-table-detail td:first-child.rowspan {
  border-left: 1px solid;
}
.inspectTimeoutDetailData-table-detail thead th {
  color: #000000 !important;
  background-color: #cccccc !important;
}
.inspectTimeoutDetailData-table-detail tr th:nth-child(1),
.inspectTimeoutDetailData-table-detail tr td:nth-child(1) {
  width: 90px;
  min-width: 90px;
}
.inspectTimeoutDetailData-table-detail tr th:nth-child(2),
.inspectTimeoutDetailData-table-detail tr td:nth-child(2) {
  width: 90px;
  min-width: 90px;
}
.inspectTimeoutDetailData-table-detail tr th:nth-child(3),
.inspectTimeoutDetailData-table-detail tr td:nth-child(3) {
  width: 115px;
  min-width: 115px;
}
.inspectTimeoutDetailData-table-detail tr th:nth-child(4),
.inspectTimeoutDetailData-table-detail tr td:nth-child(4) {
  width: 115px;
  min-width: 115px;
}
.inspectTimeoutDetailData-table-detail tr th:nth-child(5),
.inspectTimeoutDetailData-table-detail tr td:nth-child(5) {
  width: 90px;
  min-width: 90px;
}
.inspectTimeoutDetailData-table-detail tr th:nth-child(6),
.inspectTimeoutDetailData-table-detail tr td:nth-child(6) {
  width: 165px;
  min-width: 165px;
}
.inspectTimeoutDetailData-table-detail tr th:nth-child(7),
.inspectTimeoutDetailData-table-detail tr td:nth-child(7) {
  width: 165px;
  min-width: 165px;
}
.inspectTimeoutDetailData-table-detail tr th:nth-child(8),
.inspectTimeoutDetailData-table-detail tr td:nth-child(8) {
  width: 115px;
  min-width: 115px;
}
</style>



// WEBPACK FOOTER //
// src/components/inspectTimeoutDetailData.vue